(function () {
  'use strict';

  function HeroSlideshow(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('[data-hero-pagination-btn]'));
    this.current = 0;
    this.timer = null;
    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length < 2) return;

    this.bindEvents();
    if (this.autoplay && !this.reducedMotion) this.play();
  }

  HeroSlideshow.prototype.bindEvents = function () {
    var self = this;

    this.buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-index'), 10);
        self.goTo(index);
        self.restart();
      });
    });

    this.root.addEventListener('mouseenter', function () {
      self.pause();
    });
    this.root.addEventListener('mouseleave', function () {
      if (self.autoplay && !self.reducedMotion) self.play();
    });
    this.root.addEventListener('focusin', function () {
      self.pause();
    });
    this.root.addEventListener('focusout', function () {
      if (self.autoplay && !self.reducedMotion) self.play();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.pause();
      } else if (self.autoplay && !self.reducedMotion) {
        self.play();
      }
    });

    var touchStartX = 0;
    this.root.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.touches[0].clientX;
      },
      { passive: true }
    );
    this.root.addEventListener(
      'touchend',
      function (event) {
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) < 40) return;
        if (deltaX < 0) {
          self.next();
        } else {
          self.prev();
        }
        self.restart();
      },
      { passive: true }
    );
  };

  HeroSlideshow.prototype.goTo = function (index) {
    if (index === this.current) return;
    var nextIndex = (index + this.slides.length) % this.slides.length;

    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    if (this.slides[this.current].tagName === 'A') {
      this.slides[this.current].setAttribute('tabindex', '-1');
    }
    this.slides[nextIndex].classList.add('is-active');
    this.slides[nextIndex].removeAttribute('aria-hidden');
    this.slides[nextIndex].removeAttribute('tabindex');

    if (this.buttons[this.current]) {
      this.buttons[this.current].classList.remove('is-active');
      this.buttons[this.current].setAttribute('aria-selected', 'false');
    }
    if (this.buttons[nextIndex]) {
      this.buttons[nextIndex].classList.add('is-active');
      this.buttons[nextIndex].setAttribute('aria-selected', 'true');
    }

    this.current = nextIndex;
  };

  HeroSlideshow.prototype.next = function () {
    this.goTo(this.current + 1);
  };

  HeroSlideshow.prototype.prev = function () {
    this.goTo(this.current - 1);
  };

  HeroSlideshow.prototype.play = function () {
    var self = this;
    this.pause();
    this.timer = window.setInterval(function () {
      self.next();
    }, this.speed);
  };

  HeroSlideshow.prototype.pause = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  HeroSlideshow.prototype.restart = function () {
    if (this.autoplay && !this.reducedMotion) this.play();
  };

  function init(scope) {
    scope.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
      if (root.heroSlideshowInstance) return;
      root.heroSlideshowInstance = new HeroSlideshow(root);
    });
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-hero-slideshow]');
    if (root && root.heroSlideshowInstance) {
      root.heroSlideshowInstance.pause();
    }
  });
})();